import { useState, useEffect, useRef } from "react";

export const useIntersection = (
    element: { current: Element },
    rootMargin: any
) => {
    const [isVisible, setIsVisible] = useState(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // Only update state if component is still mounted
                if (isMountedRef.current) {
                    setIsVisible(entry.isIntersecting);
                }
            },
            { rootMargin }
        );

        const observeSchedule = setTimeout(() => {
            if (element?.current && element?.current instanceof HTMLElement) {
                observer.unobserve(element.current);
            }

            if (element.current) {
                observer.observe(element.current);
            }
        }, 1000);

        return () => {
            isMountedRef.current = false;
            clearTimeout(observeSchedule);

            // Disconnect the observer completely
            observer.disconnect();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return isVisible;
};
// https://www.webtips.dev/webtips/react-hooks/element-in-viewport
